import React from "react";
import * as Icons from "lucide-react";
import { useContent } from "../contexts/ContentContext";

export default function Services({ onEnquire }) {
  const { content } = useContent();
  const { services } = content;

  return (
    <section id="services" className="py-20 lg:py-28 bg-[#f6f7f5] relative overflow-hidden">
      <div className="absolute top-0 left-0 w-72 h-72 rounded-full bg-orange-200/30 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-72 h-72 rounded-full bg-emerald-200/30 blur-3xl pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-block px-3 py-1 rounded-full bg-emerald-50 text-[#0a4f47] text-xs font-semibold tracking-wider mb-4">
            WHAT WE DELIVER
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900">
            Solutions <span className="text-orange-500">We Deliver</span>
          </h2>
          <p className="text-slate-600 mt-4">
            End-to-end clean energy infrastructure for homes, businesses, industries and the grid.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-5">
          {services.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Sun;
            return (
              <button
                key={`${s.title}-${i}`}
                onClick={onEnquire}
                className="group relative text-left rounded-2xl bg-white border border-slate-200 hover:border-orange-300 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 p-5 overflow-hidden"
              >
                <div className="absolute -top-10 -right-10 w-28 h-28 rounded-full bg-orange-50 group-hover:bg-orange-100 transition-colors" />
                <div className="relative">
                  <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#0a4f47] to-[#0e6e63] flex items-center justify-center shadow-md group-hover:from-orange-500 group-hover:to-orange-600 transition-all">
                    <Icon className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="mt-4 font-bold text-slate-900 text-[15px] leading-snug group-hover:text-[#0a4f47] transition-colors">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-[13px] text-slate-600 leading-relaxed line-clamp-3">
                    {s.description}
                  </p>
                  <div className="mt-3 inline-flex items-center gap-1.5 text-orange-600 text-xs font-semibold group-hover:gap-2.5 transition-all">
                    Learn more
                    <Icons.ArrowRight className="w-3.5 h-3.5" />
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
